/*
 *
 * @desc: 产品额外绑定服务（延保、care）
 * @author: haifn
 * @time: 2021/4/23 2:24 下午
 *
 */

import { fetchQueryParams, getLANG } from '@/utils';
import { armsErrorSend } from '@/utils/libs/armsErrorSend';
import { cloneDeep } from 'lodash';
import CareConfig from './Care.config';
import InsuranceConfig from './Insurance.config';
import CarePulsConfig from './CarePlus.config';
import { ExtraServiceType } from '@/types/extraService';

const LANG = getLANG();

// 初始化DataMap中的group字段
function configToGroup(Config) {
  let group = [];
  // eslint-disable-next-line guard-for-in
  for (const key of Object.keys(Config)) {
    const item = Config[key];
    group.push({
      cid: item.cid,
      // defaultUnSelect: item.defaultUnSelect || false,
      defaultUnSelect: true, // 默认全部未选中
      replaceCostCid: item.replaceCostCid || null,
    });
  }
  return group;
}

let DataMap = {
  care_plus: {
    pid: [521, 523, 549, 586, 590, 636],
    urlKey: {
      521: 'flexicare-ace-pro',
      523: 'flexicare-x4',
      549: 'flexicare-go-3s',
      586: 'flexicare-link-2',
      590: 'flexicare-ace-pro2',
      636: 'flexicare-flow-2-pro',
    },
    desc: 'Care Plus服务',
    enabled: CareConfig.enabledCountry,
    productPage: {
      productName: LANG['bindServices.productPage.flexicare_productName'],
      itemTitle: LANG['bindServices.productPage.carePlusTitle'],
      itemDesc: LANG['bindServices.productPage.carePlusDesc'],
      itemNoNeedBtn: LANG['bindServices.productPage.noNeedBtnCarePlus'],
      thumb:
        'https://res.insta360.com/static/3ec6a1175af675204e2cf476bf898748/%E5%AE%98%E6%96%B9%E5%95%86%E5%9F%8E%E4%B8%BB%E6%9C%BA%E4%B8%BB%E5%9B%BE@780w.png',
    },
    carePlusProductPage: [
      LANG['productNew.carePlus.point_1'],
      LANG['productNew.carePlus.point_2'],
      LANG['productNew.carePlus.point_3'],
      LANG['productNew.carePlus.point_4'],
    ],
    learnMoreModal: {
      title: LANG['bindServices.learnMoreModal.carePlus_title'],
      desc: LANG['bindServices.learnMoreModal.carePlus_desc'],
      link: LANG['bindServices.learnMoreModal.carePlus_learn_more_link'],
      pointList: [
        {
          imgUrl: 'https://res.insta360.com/static/fcd9c0c316e3ed3b9e7c47d4a6efdd2e/Frame%201973770805.png',
          title: LANG['bindServices.learnMoreModal.carePlus_point_1_title'],
          desc: LANG['bindServices.learnMoreModal.carePlus_point_1_desc'],
        },
        {
          imgUrl:
            'https://res.insta360.com/static/592af4828b68f5abaeb3285d4a60cba0/Buy%20ONE%20RS%20-%20Interchangeable%20Lens%20Action%20Cam%20-%20Insta360%2010.png',
          title: LANG['bindServices.learnMoreModal.carePlus_point_2_title'],
          desc: LANG['bindServices.learnMoreModal.carePlus_point_2_desc'],
        },
        {
          imgUrl: 'https://res.insta360.com/static/01d2419f98054ec7184dc285957ff924/Frame.png',
          title: LANG['bindServices.learnMoreModal.carePlus_point_3_title'],
          desc: LANG['bindServices.learnMoreModal.carePlus_point_3_desc'],
        },
      ],
    },
    addModal: {
      title: LANG['bindServices.addServicesModal.careTitle'],
    },
    thumb:
      'https://res.insta360.com/static/3ec6a1175af675204e2cf476bf898748/%E5%AE%98%E6%96%B9%E5%95%86%E5%9F%8E%E4%B8%BB%E6%9C%BA%E4%B8%BB%E5%9B%BE@780w.png',
    serviceType: 'care_plus',
    group: configToGroup(CarePulsConfig.Data),
  },
  care: {
    pid: [141],
    urlKey: 'care',
    desc: 'Care服务',
    enabled: CareConfig.enabledCountry,
    productPage: {
      itemTitle: LANG['bindServices.productPage.careTitle'],
      itemDesc: LANG['bindServices.productPage.careDesc'],
      itemNoNeedBtn: LANG['bindServices.productPage.noNeedBtnCare'],
      2201: LANG['bindServices.productPage.FlowCareDesc'],
      thumb: 'https://res.insta360.com/static/assets/storage/20210512/0bfe2c83ee285363625067a0853effac/care.png',
    },
    learnMoreModal: {
      desc: {
        1757: LANG['bindServices.learnMoreModal.careDescONERS'],
        1472: LANG['bindServices.learnMoreModal.careDescONER'],
        default: LANG['bindServices.learnMoreModal.careDesc'],
      },
    },
    addModal: {
      title: LANG['bindServices.addServicesModal.careTitle'],
    },
    thumb: 'https://res.insta360.com/static/assets/storage/20210512/0bfe2c83ee285363625067a0853effac/care.png',
    serviceType: 'care', // 用于下单
    group: [],
  },
  extend: {
    pid: [327],
    urlKey: 'warranty_service',
    desc: '延保服务',
    enabled: InsuranceConfig.enabledCountry,
    productPage: {
      productName: LANG['bindServices.productPage.Warranty_productName'],
      itemTitle: LANG['bindServices.productPage.insuranceTitle'],
      itemTitle_2: LANG['bindServices.productPage.insuranceTitle2.0'],
      itemDesc: LANG['bindServices.productPage.insuranceDesc'],
      itemNoNeedBtn: LANG['bindServices.productPage.noNeedBtnInsurance'],
      thumb: 'https://res.insta360.com/static/assets/storage/20210512/c9e955de319c1ba031cd844b15bf7e3f/insurance.png',
    },
    learnMoreModal: {
      desc: {
        default: LANG['bindServices.learnMoreModal.insuranceDesc'],
      },
    },
    addModal: {
      title: LANG['bindServices.addServicesModal.insuranceTitle'],
    },
    thumb: 'https://res.insta360.com/static/assets/storage/20210512/c9e955de319c1ba031cd844b15bf7e3f/insurance.png',
    serviceType: 'extend', // 用于下单
    group: [],
  },
};

/**
 *
 * @description 获得commodities里面的care_plus对应的置换费id
 * @param {[]} commodities
 * @param {boolean} all 是否返回所有置换费id
 * @returns {number[] | []}
 */
function getCarePlusCostCids(commodities = [], all = false) {
  if (all) {
    // 返回所有置换费id
    return DataMap['care_plus'].enabled ? DataMap['care_plus']['group'].map((o) => o.replaceCostCid) : [];
  }
  if (!commodities || commodities.length === 0) return [];
  const replaceCostCids = DataMap['care_plus']['group']?.reduce((pre, cur) => {
    if (commodities.includes(cur.cid)) {
      pre.push(cur.replaceCostCid);
    }
    return pre;
  }, []);
  return replaceCostCids;
}

/**
 *
 * @description 接口获取增值服务的详细信息set到DataMap中
 * @param {[]} commodities
 * @returns
 */
function setCommodityToMap(commodities) {
  if (!commodities || commodities.length === 0) return;
  // 给增值服务id分类（care、extend、care_plus
  const commoditiesClassification = commodities.reduce((pre, cur) => {
    if (cur.serviceType) {
      (pre[cur.serviceType] = pre[cur.serviceType] || []).push(cur);
    }
    return pre;
  }, {});
  for (const key of Object.keys(DataMap)) {
    if (key === 'care_plus') {
      // care_plus拥有置换费，保持原来的处理方式
      DataMap[key]['group'].forEach((o) => {
        const _commodity = commoditiesClassification[key]?.filter((c) => c.id === o.cid)[0];
        o.commodity = _commodity ? cloneDeep(_commodity) : null;
      });
    } else {
      const _commodityList = [];
      commoditiesClassification[key]?.forEach?.((o) => {
        const _commodity = {
          cid: o.id,
          defaultUnSelect: true, // 默认全部未选中
          commodity: o ? cloneDeep(o) : null,
        };
        _commodityList.push(_commodity);
      });
      DataMap[key]['group'] = _commodityList;
    }
  }
}

/**
 *
 * @param {number} curSelectCids 选中套餐的care & 延保 cid
 * @param {number} curSelectCommodityCount
 * @returns {array} 当前套餐绑定的增值服务 & 数量
 */
function getProductExtraBindService(curSelectCids, curSelectCommodityCount) {
  const list = [];
  for (const key of Object.keys(DataMap)) {
    if (Object.hasOwnProperty.call(DataMap, key)) {
      DataMap[key]['group'].forEach((o) => {
        if (curSelectCids.includes(o.cid) && o.commodity) {
          // 默认不选中care、延保
          // 1. 广告商品query.freelist BI投广参数（谷歌渠道:gmc）
          // 2. Insta360 Link
          const fromGoogleAds = fetchQueryParams('freelist') === 'gmc';
          const defaultUnSelect = o.defaultUnSelect || fromGoogleAds;
          o.extraType = key;
          o.productPage = DataMap[key]['productPage'];
          o.commodity.serviceType = DataMap[key]['serviceType']; // 服务类型，用于下单
          // 默认选中产品页care，谷歌广告流量除外
          // 数量与产品页的count保持一致
          o.commodity.count = defaultUnSelect ? 0 : curSelectCommodityCount ?? 1;
          list.push(o);
        }
      });
    }
  }
  return list;
}

/**
 *
 * @param {object} item 购物车items列表
 * @param {boolean} filterCare 是否过滤care, 仅返回非care类型的增值服务
 * @returns {array} 购物车页当前产品绑定的增值服务
 */
function getCartItemMatchService({ item, filterCare }) {
  const cids = item?.bindClimbServices?.map?.((service) => service.serviceCommodityId).filter((o) => !!o) || [];
  if (!item || cids.length === 0) return [];
  let list = getProductExtraBindService(cids);

  let result = [];
  list.forEach((i) => {
    const exist = item.bind_services.filter((o) => o.id === i.cid)[0];
    if (!exist) result.push(i);
  });

  if (filterCare) {
    result = result.filter((o) => !o.extraType.includes('care'));
  }

  return result;
}

/**
 * @description 通过增值服务ID找到对应的配置
 * @param {number} pid
 * @returns {object}
 */
function getServiceInfo(pid) {
  for (const key of Object.keys(DataMap)) {
    if (Object.hasOwnProperty.call(DataMap, key) && DataMap[key].pid.includes(pid)) {
      return DataMap[key];
    }
  }
}

/**
 *
 * @description 获取购物车的增值服务列表
 * @param {object} cartItems
 * @returns {array}
 */
function getCartItemServiceList(cartItems) {
  return new Promise((resolve) => {
    try {
      let result = [];
      const _DataMap = cloneDeep(DataMap);
      for (const i of Object.keys(_DataMap)) {
        if (Object.hasOwnProperty.call(_DataMap, i)) {
          const dataItem = _DataMap[i];
          dataItem['group'].forEach((groupItem) => {
            groupItem.cartItems = [];
            cartItems.forEach((cartItem) => {
              if (groupItem?.cid === cartItem?.bindClimbServices?.serviceCommodityId) {
                const hasCartItemService = cartItem.bind_services.filter((o) => o.id === groupItem.cid)[0];
                if (!hasCartItemService) {
                  groupItem.cartItems.push(cartItem);
                }
              }
            });
          });
          dataItem['group'] = dataItem['group'].filter((o) => o.cartItems && o.cartItems.length > 0 && o.commodity);
          dataItem['type'] = i;
          result.push(dataItem);
        }
      }
      result = result.filter((o) => o.enabled).filter((o) => o?.group?.length > 0);
      resolve(result);
    } catch (e) {
      armsErrorSend(e, { filename: 'extraBindService.config.js getCartItemServiceList' });
      resolve([]);
    }
  });
}

function isExtraBindService(serviceType) {
  if (!serviceType) return false;
  return Object.values(ExtraServiceType).includes(serviceType);
}

/**
 * @description 判断当前国家的care延保销售状态
 * ————————————
 * 1——启用延保和保险
 * 2——启用延保 不启用保险
 * 3——不启用延保 不启用保险
 */
export const getCountryInsuranceState = (code) => {
  let serviceType = 3;
  if (CareConfig?.enabledCountryMap?.includes(code) && InsuranceConfig?.enabledCountryMap?.includes(code))
    serviceType = 1;
  if (CareConfig?.enabledCountryMap?.includes(code) && !InsuranceConfig?.enabledCountryMap?.includes(code))
    serviceType = 2;

  return serviceType;
};

export default {
  DataMap,
  setCommodityToMap,
  getProductExtraBindService,
  getCartItemMatchService,
  getServiceInfo,
  getCartItemServiceList,
  getCountryInsuranceState,
  getCarePlusCostCids,
  isExtraBindService,
};
